import { Typography } from '@mui/material';

export const Tex = Typography;
